<template>

    <ContentsPageTitleV2 capital="LOREM IPSUM DOLOR SIT AMET, CONSETETUR SADIPSCING ELITR SFE" title="Use Case" description="EV and Electrification"/>
    <ContentsCard :contents="ADAS" />


</template>

<script setup>
useHead({
  title:'EV Electrification - NAGASE THAILAND Engineering Plastics',
})
const ADAS = [
  {
    "pdf":true,
    "img":"/pages/products/use-cases/ab09.jpg",
    "title":"Battery Bus Bar Application Sheet NA",
    "to":"/pages/products/use-cases/Battery_Bus_Bar_Application_Sheet_NA.pdf"
  },
  {
    // ไม่มีไฟล์ pdf
    "pdf":true,
    "img":"/pages/products/use-cases/sa01.jpg",
    "title":"Dupont Battery Graphic",
    "to":"/pages/products/use-cases/01.pdf"
  },
  {
    "pdf":true,
    "img":"/pages/products/use-cases/bike.jpg",
    "title":"E-bike Application Sheet NA FNL",
    "to":"/pages/products/use-cases/bike.pdf"
  },
  {
    "pdf":true,
    "img":"/pages/products/use-cases/toy.jpg",
    "title":"eCool Application Sheet NA FNL",
    "to":"/pages/products/use-cases/eCool_Application_Sheet_NA_FNL.pdf"
  },
  {
    "pdf":true,
    "img":"/pages/products/use-cases/electrics.jpg",
    "title":"EE EV Infrastructure Sell Sheet A4 Final",
    "to":"/pages/products/use-cases/EE-EV-Infrastructure-Sell-Sheet-A4-Final.pdf"
  },
  {
    "pdf":true,
    "img":"/pages/products/use-cases/b02.jpg",
    "title":"Electric Vehicle Battery Pack Brochure",
    "to":"/pages/products/use-cases/Electric_Vehicle_Battery_Pack_Brochure.pdf"
  },
  {
    "pdf":true,
    "img":"/pages/products/use-cases/fyu.jpg",
    "title":"Orange Materials Product Sheet NA FNL",
    "to":"/pages/products/use-cases/Orange_Materials_Product_Sheet_NA_FNL.pdf"
  },
  {
    "pdf":true,
    "img":"/pages/products/use-cases/dfr.jpg",
    "title":"SABIC Elcres HTV150A Film Flyer",
    "to":"/pages/products/use-cases/SABIC_ELCRESHV150AFILMFLYER.pdf"
  },
  {
    "pdf":true,
    "img":"/pages/products/use-cases/san.jpg",
    "title":"SABIC ULTEM UTF120 Film Flyer",
    "to":"/pages/products/use-cases/SABICULTEMUTF20FilmFlyer.pdf"
  },
  {
    "pdf":true,
    "img":"/pages/products/use-cases/ngv.jpg",
    "title":"SABIC Automotive Empowering Electric Vehicle Supply Equipment EVSE",
    "to":"/pages/products/use-cases/SABIC-Automotive-EMPOWERINGELECTRICVEHICLESUPPLYEQUIPMENT-EVSE.pdf"
  },
  {
    "pdf":true,
    "img":"/pages/products/use-cases/ver.jpg",
    "title":"NORYL RESIN Solusions for electric vehicle battery modules",
    "to":"/pages/products/use-cases/NORYLRESINSOLUTIONSFORELECTRICVEHICLEBATTERYMODULES.pdf"
  }

]
</script>